// A list of schedule conflicts with "Save anyway" (SPEC §6.1, §7.4).

import type { ConflictItem } from "../api/types";
import { t, translateCode } from "../i18n/i18n";
import { createButton, createElement } from "./dom";

/** The conflicts and a button that repeats the save with confirm: true. */
export function buildConflictList(conflicts: ConflictItem[], onSaveAnyway: () => Promise<void>): HTMLElement {
  const box: HTMLDivElement = createElement("div", "conflict-box");
  box.setAttribute("role", "alert");
  box.append(createElement("p", "", t("lesson.conflictsTitle")));
  const list: HTMLUListElement = createElement("ul");
  for (const conflict of conflicts) {
    list.append(createElement("li", "", translateCode("conflicts", conflict.code, conflict.params)));
  }

  box.append(list, createButton(t("app.saveAnyway"), onSaveAnyway, "button-warning"));
  return box;
}
